import { createContext, useContext } from "react";

interface KnowledgeActionsContextValue {
  openNewNoteModal: () => void;
}

export const KnowledgeActionsContext =
  createContext<KnowledgeActionsContextValue>({
    openNewNoteModal: () => {},
  });

export function useKnowledgeActions() {
  return useContext(KnowledgeActionsContext);
}
